import { AssetLoader } from '@nolimitcity/slot-game/bin/asset/AssetLoader';
import { ISymbolConfig, ISymbolDim } from '../../../core/reel/symbol/config/IReelSymbolStruct';
import { SymbolData } from '../../../core/reel/symbol/config/SymbolData';

export enum SymbolGfxColor {
    WHITE = 0xffffff,
    BLACK = 0x000000,
    RED = 0xff0000,
    GREEN = 0x00ff00,
    BLUE = 0x0000ff,
    ORANGE = 0xffa500,
    PINK = 0xffc0cb,
    GOLD = 0xffd700,
}

export class BeheadedSymbolData extends SymbolData {
    protected preDefinedSymbols: ISymbolConfig[] = [
        { NAME: 'L1' },
        { NAME: 'L2' },
        { NAME: 'L3' },
        { NAME: 'L4' },
        { NAME: 'L5' },
        { NAME: 'M1' },
        { NAME: 'M2' },
        { NAME: 'M3' },
        { NAME: 'M4' },
        { NAME: 'M5' },
        { NAME: 'SW' },
        { NAME: 'W' },
        { NAME: 'S' },
        {
            NAME: 'SW1',
            NORMAL_STATES: {
                normal: {
                    DIM: {
                        WIDTH: 112,
                        HEIGHT: 131,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: 'sw_sad_indicator',
                },
            },
        },
        {
            NAME: 'SW2',
            NORMAL_STATES: {
                normal: {
                    DIM: {
                        WIDTH: 112,
                        HEIGHT: 131,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: 'sw_laugh_indicator',
                },
            },
        },
        {
            NAME: 'SW3',
            NORMAL_STATES: {
                normal: {
                    DIM: {
                        WIDTH: 112,
                        HEIGHT: 131,
                        PADDING_X: 0,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: 'sw_angry_indicator',
                },
            },
        },
    ];

    protected SpecialSymbols: string[] = ['S', 'W', 'SW'];

    constructor(loader: AssetLoader, dim: ISymbolDim) {
        super(loader, dim);
    }
}
